import styled from 'styled-components';

export const IconContainer = styled.div`
  position: relative;
  left: 140px;
  padding: 30px 0px 0px 0px;
`;

export const ShareDataContainer = styled.div`
  padding-top: 20px;
  font-family: Rubik;
  color: #373f45;
`;

export const Title = styled.div`
  font-family: RubikMedium;
  font-size: 15pt;
  color: #454f63;
`;

export const SharedDataContent = styled.div`
  padding: 26px 22px 20px 22px;
`;

export const ContentText = styled.span`
  font-family: 'RubikLight';
  font-size: 11pt;
`;

export const EvidenceText = styled.span`
  font-family: RubikMedium;
  font-size: 11pt;
`;

export const FooterButtonContainer = styled.div``;

export const Separator = styled.div`
  border 0.5pt solid #B0B8BE;
  border-color: #B0B8BE;
  width: 200px;
  margin: 10px 0 10px 0;
`;

export const MevoPrivatePolicyLink = styled.a`
  font-family: RubikMedium;
  color: #707070;
  font-size: 10pt;
  text-decoration: underline;
  margin-right: 50px;
`;

export const LoadingText = styled.span`
  font-family: RubikMedium;
  color: #2493eb;
  font-size: 17pt;
`;

export const LoadingDataContent = styled.div`
  padding: 180px 22px 200px 22px;
`;

export const LoadingDataContainer = styled.div`
  font-family: Rubik;
  color: #373f45;
`;
